import { userInfo } from '../request/user-info';
const GATES_OVERWRITE_KEY = 'reporting:gatesOverwrite';
export const getGateInfoWithOverwrite = () => {
  const gatesOverwrite = sessionStorage.getItem(GATES_OVERWRITE_KEY);
  return gatesOverwrite ? Promise.resolve({
    gates: gatesOverwrite
  }) : userInfo();
};
export const isUngatedForGate = ({
  gateToBeChecked,
  gates
}) => {
  const gatesOverwrite = sessionStorage.getItem(GATES_OVERWRITE_KEY);
  const parsedGates = gatesOverwrite || gates;
  return parsedGates.includes(gateToBeChecked);
};
export const isUngatedForGateUserInfo = ({
  gate
}) => {
  return userInfo().then(({
    gates = []
  }) => {
    return isUngatedForGate({
      gateToBeChecked: gate,
      gates
    });
  });
};